<template>
  <path
    :d="d"
    :style="{ fill: color }"
    @click="emitThis($event, 'click')"
    @mouseover="emitThis($event, 'mouseover')"
    @mouseout="emitThis($event, 'mouseout')"
    :class="{
      'pointer-events-none': !selectionable,
      'cursor-pointer': selectionable
    }"
  >
  </path>
</template>

<script>
// @click="listeners['click']('click', id)"
export default {
  props: {
    d: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    selectionable: {
      type: Boolean,
      default: true
    }
    
  },

  updated() {},
  methods: {
    emitThis(event, type) {
      this.$emit('_'+type, event, this.id)
    }
  }
}
</script>

<style>
</style>